export default __webpack_public_path__ + "static/media/edit.b63541da.svg";